import {
    ActionType,
    getNotificationEmailAction
} from "./actions";
import { NotificationEmailJson } from "../../../domain/user/notification/NotificationEmail";
import { createSlice } from "@reduxjs/toolkit";

export type UserState = Readonly<{
    notifications: NotificationEmailJson[],
    processing: number
}>;

const userInitialState: UserState = {
    notifications: [],
    processing: 0
};

const slice = createSlice({
    name: ActionType.base,
    initialState: userInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                getNotificationEmailAction.pending,
                (state) => {
                    state.processing += 1;
                }
            )
            .addCase(
                getNotificationEmailAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    const { notifications } = payload;
                    state.notifications = notifications;
                    state.processing -= 1;
                }
            )
            .addCase(
                getNotificationEmailAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            );
    }
});

export const userReducer = slice.reducer; 
